import React, { useState } from 'react'
import { Button } from '@headtrip/components-react'
import classnames from 'classnames'
import copy from 'copy-to-clipboard'
import * as styles from './PromoButton.module.scss'

const PromoButton = props => {
  const [wasCopied, setWasCopied] = useState(false)

  const { code, className = '', ...rest } = props
  const classNames = classnames(className,
    wasCopied && styles.btnRipple,
    'mw-100'
  )

  const onCopy = () => {
    const copySuccessful = copy(code)
    setWasCopied(copySuccessful)
  }

  return (
    <Button
      className={classNames}
      variant="white"
      onClick={onCopy}
      onAnimationEnd={() => setWasCopied(false)}
      style={{ whiteSpace: 'nowrap' }}
      {...rest}
    >
      {code}
      <i className="fa fa-copy ml-2 d-none d-xl-inline-block" />
    </Button>
  )
}

export default PromoButton
